import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Footer() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const subscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await api.post("/newsletter", { email });
            toast.success("Bienvenue dans la maison. Vous êtes inscrit.");
            setEmail("");
        } catch {
            toast.error("Erreur — réessayez.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className="mt-24 border-t border-white/10 bg-[#0A0A0C]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="font-serif-luxe text-2xl tracking-[0.2em] chrome-text mb-4">VVS HÉRITAGE</div>
                    <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
                        Bijoux en argent 925 sertis de moissanite certifiée GRA.
                        Conçus à Québec, portés partout. L'éclat diamant, la légitimité totale.
                    </p>
                    <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md" data-testid="newsletter-form">
                        <input
                            data-testid="newsletter-email-input"
                            type="email"
                            required
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="flex-1"
                        />
                        <button data-testid="newsletter-submit-btn" type="submit" disabled={loading} className="btn-primary whitespace-nowrap !py-3">
                            Rejoindre
                        </button>
                    </form>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Boutique</div>
                    <div className="flex flex-col gap-3 text-sm text-slate-300">
                        <Link data-testid="footer-link-chaines" to="/boutique/chaines" className="hover:text-white transition-colors">Chaînes</Link>
                        <Link data-testid="footer-link-pendentifs" to="/boutique/pendentifs" className="hover:text-white transition-colors">Pendentifs</Link>
                        <Link data-testid="footer-link-bracelets" to="/boutique/bracelets" className="hover:text-white transition-colors">Bracelets</Link>
                        <Link data-testid="footer-link-boucles" to="/boutique/boucles" className="hover:text-white transition-colors">Boucles d'oreille</Link>
                        <Link data-testid="footer-link-catalogue" to="/boutique" className="hover:text-white transition-colors">Catalogue complet</Link>
                        <Link data-testid="footer-link-suivi" to="/suivi" className="hover:text-white transition-colors">Suivi commande</Link>
                    </div>
                </div>
                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Confiance</div>
                    <div className="flex flex-col gap-3 text-sm text-slate-300">
                        <Link data-testid="footer-link-apropos" to="/a-propos" className="hover:text-white transition-colors">À propos</Link>
                        <Link data-testid="footer-link-authenticite" to="/authenticite" className="hover:text-white transition-colors">Authenticité & GRA</Link>
                        <Link data-testid="footer-link-retour" to="/politique-de-retour" className="hover:text-white transition-colors">Politique de retour</Link>
                        <Link data-testid="footer-link-contact" to="/contact" className="hover:text-white transition-colors">Contact</Link>
                        <Link data-testid="footer-link-cgv" to="/cgv" className="hover:text-white transition-colors">CGV</Link>
                        <Link data-testid="footer-link-confidentialite" to="/confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-slate-500 tracking-wider uppercase">
                    <div>© {new Date().getFullYear()} VVS Héritage — Québec, Canada</div>
                    <div data-testid="footer-trust-badges" className="flex items-center gap-4">
                        <span>Argent 925</span>
                        <span>·</span>
                        <span>Moissanite GRA</span>
                        <span>·</span>
                        <span>Livraison gratuite dès 500 $</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
